module.exports = __webpack_public_path__ + "static/media/assa-muti-parking-selected.edf50847.svg";